"use client";

import { ReactNode } from "react";

export interface SettingsSectionProps {
  /** Section title */
  title: string;
  /** Section description */
  description?: string | ReactNode;
  /** Section content */
  children: ReactNode;
}

export default function SettingsSection({
  title,
  description,
  children,
}: SettingsSectionProps) {
  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-1">
        <h4 className="text-xl font-semibold">{title}</h4>
        {description && (
          <p className="text-sm text-secondary-blue">{description}</p>
        )}
      </div>
      <div className="flex flex-col gap-6">{children}</div>
    </div>
  );
}
